import {hideError, showError} from "../actions/actions";
import axios from "axios";
import {API_URL} from "../config";
import {
    GET_NOTIFICATION_ERROR,
} from "../types/types";
import {showAccessDeniedNotifications, showNotFoundNotifications} from "../actions/actionsNotifications";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {getBranchDetailById} from "./apiBranchList";
import {GET_AUDIO, GET_AUDIO_PAGINATION, GET_AUDIO_URL_ID, GET_AUDIO_URL_ID_LOADING, GET_AUDIOS, SHOW_AUDIO_CREATE_LOADER, SHOW_AUDIO_DETAIL_LOADING} from "../types/typesAudioList";
import {setAudioDialogVisible, setAudioErrorField, showAudioLoader} from "../actions/actionsAudio";
import {setUserError} from "../actions/actionsUsersList";
import {getStatusesListWithPaginationFilterAndSorting} from "./apiStatusesList";
import {GET_ALL_AUDIO_GROUP, GET_QUEUE_DIRECTORIES_QUEUE_AUDIO_TYPE} from "../types/typesQueue";
import {fetchAllAudioInGroupsCatalog} from "./sharedCatalogRequests";

let dataSort = {
    pageNumber: 1,
    pageSize: 10,
    sort: {
        orderBy: "Id",
        isDesc: true
    }
}

export function getAllAudioWithPagination(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showAudioLoader(true))
        dispatch(hideError())
        axios.post(`${API_URL}Audio/GetAudioGroupsWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dataSort = data;
                dispatch({type: GET_AUDIOS, payload: response.data.data.items})
                dispatch({type: GET_AUDIO_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAudioLoader(false));
                dispatch(hideError());
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export const isValidAudioGroupId = (id: any) => {
    if (id == null || id === '') {
        return false;
    }
    const asString = String(id);
    if (
        asString.startsWith('queue-') ||
        asString.startsWith('campaign-') ||
        asString.startsWith('missing:')
    ) {
        return false;
    }
    return Number.isFinite(Number(asString));
};

export const displayAudioGroupId = (
    catalogGroupId: any,
    audioId: any,
    groupName?: string | null,
    prefix: 'queue' | 'campaign' = 'queue'
) => {
    if (isValidAudioGroupId(catalogGroupId)) {
        return catalogGroupId;
    }
    if (groupName) {
        return `missing:${groupName}`;
    }
    if (audioId == null || audioId === '') {
        return null;
    }
    return `${prefix}-${audioId}`;
};

export function getAudioById(id: number, jwtToken: any, remote?: boolean) {
    return (dispatch: (arg0: any) => void) => {
        if (!isValidAudioGroupId(id)) {
            return;
        }
        dispatch({type: SHOW_AUDIO_DETAIL_LOADING, payload: true});
        dispatch(hideError());
        axios.get(`${API_URL}Audio/GetAudioGroupById?audioGroupId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const data = response.data?.data;
                if (!data) {
                    return dispatch(showError());
                }
                dispatch({type: GET_AUDIO, payload: data})
                if (remote) {
                    dispatch(setAudioDialogVisible(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_AUDIO_DETAIL_LOADING, payload: false});
            })
    }
}

export function createAudio(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setAudioErrorField(null));
        dispatch(hideError());
        dispatch({type: SHOW_AUDIO_CREATE_LOADER, payload: true});
        axios.post(`${API_URL}Audio/CreateGroupAudio`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO, payload: response.data.data})
                    dispatch(getAllAudioWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400) {
                    let errorMessage = {"nameUniq": "Назва вже існує"};
                    dispatch(setAudioErrorField(errorMessage));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_AUDIO_CREATE_LOADER, payload: false});
            })
    }
}

export function updateAudio(data: any, jwtToken: any, branchId?: number | null) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setAudioErrorField(null));
        dispatch(hideError());
        dispatch({type: SHOW_AUDIO_CREATE_LOADER, payload: true});
        axios.post(`${API_URL}Audio/UpdateGroupAudio`, data, {
            headers: {
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO, payload: response.data.data})
                    dispatch(getAllAudioWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    if (branchId) {
                        dispatch(getBranchDetailById(branchId, jwtToken));
                    }
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400 && response.data.message !== "Заборонено! Аудіо використовується в чергах.") {
                    let errorMessage = {"nameUniq": "Назва вже існує"};
                    dispatch(setAudioErrorField(errorMessage));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: SHOW_AUDIO_CREATE_LOADER, payload: false});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function archiveAudio(id: number, jwtToken: any, sort? : any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.post(`${API_URL}Audio/ArchiveUnArchiveAudioGroup?audioGroupId=${id}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllAudioWithPagination(sort || dataSort, jwtToken));
                    dispatch(setAudioDialogVisible(false));
                } else {
                    dispatch(getStatusesListWithPaginationFilterAndSorting(sort || dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function getAllAudio (jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        return fetchAllAudioInGroupsCatalog(jwtToken)
            .then((data) => {
                dispatch({type: GET_ALL_AUDIO_GROUP, payload: data});
                dispatch({type: GET_QUEUE_DIRECTORIES_QUEUE_AUDIO_TYPE, payload: data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function removeAudioById(id: any, audioGroupId: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.delete(`${API_URL}Audio/RemoveAudioById?audioId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAudioById(audioGroupId, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function activeInActiveAudioById(id: any, audioGroupId: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.post(`${API_URL}Audio/ActiveInActiveAudio?audioId=${id}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAudioById(audioGroupId, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function moveAudioToGroupId(audioId: number, toGroupAudioId: number, jwtToken: any, currentGroupId?: number) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.post(`${API_URL}Audio/MoveAudioToGroupId`, {
            audioId,
            toGroupAudioId
        }, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    if (currentGroupId) {
                        dispatch(getAudioById(currentGroupId, jwtToken));
                    }
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}});
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            });
    }
}

export function getTempUrlById(audioId: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch({type: GET_AUDIO_URL_ID_LOADING, payload: true});
        axios.get(`${API_URL}Audio/GetTempAudio?audioId=${audioId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO_URL_ID, payload: response.data.data});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                }
                if (e?.response?.status === 404) {
                    dispatch(showNotFoundNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
                dispatch({type: GET_AUDIO_URL_ID, payload: null});
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: GET_AUDIO_URL_ID_LOADING, payload: false});
            })
    }
}
